import { cn } from '@/utils/merge';
import { MAP_LAYERS } from '../hooks/useMapLayers';

const TOGGLES = [
	{ key: MAP_LAYERS.DELIVERIES, label: 'Διανομείς' },
	{ key: MAP_LAYERS.SHOPS, label: 'Καταστήματα' },
	{ key: MAP_LAYERS.DESTINATIONS, label: 'Προορισμοί' },
	{ key: MAP_LAYERS.TRAFFIC, label: 'Κίνηση' },
];

export const MapLayerToggles = ({ layers, toggleLayer }) => {
	// z-[1000] keeps the pills above the Google overlay panes (they top out ~104),
	// so a pin can never swallow the click.
	return (
		<div className='absolute top-2 left-2 z-[1000] flex max-w-[calc(100%-16px)] flex-col items-start gap-1.5'>
			{TOGGLES.map(({ key, label }) => (
				<button
					key={key}
					type='button'
					onClick={() => toggleLayer(key)}
					className={cn(
						'font-regular cursor-pointer rounded-full border px-2.5 py-1 text-xs tracking-wider shadow-sm transition-colors',
						layers?.[key]
							? 'border-[#0f9b9d] bg-[#0f9b9d] text-white'
							: 'border-gray-300 bg-white/90 text-gray-600 hover:bg-white',
					)}
				>
					{label}
				</button>
			))}
		</div>
	);
};
